export const checkUrlLink = (url: string) => {
  if (url.endsWith("mp4")) return "video";
  return "image";
};
